import React from "react";

import { Container } from "../components/Container";
import { Link } from "react-router-dom";

// Translation
import { useTranslation } from "react-i18next";

import {dataFR} from "../assets/data/fr"
import {dataEN} from "../assets/data/en"
import {dataNL} from "../assets/data/nl"

const Error404 = () => {

    const { i18n } = useTranslation();

    let data = dataFR;
    if (i18n.language === "fr") {
      data = dataFR;
    } else if (i18n.language === "en") {
      data = dataEN;
    } else if (i18n.language ==="nl"){
      data = dataNL;
    }


  return (
    <Container>
      {" "}
      <div className="flex items-center flex-col justify-center lg:flex-row py-28 px-6 md:px-24 md:py-20 lg:py-32 gap-16 lg:gap-28">
        <div className="w-full lg:w-1/2">
          <img
            className="hidden lg:block"
            src={data.notFound.images[1]}
            alt=""
          />
          <img
            className="hidden md:block lg:hidden"
            src={data.notFound.images[2]}
            alt=""
          />
          <img
            className="md:hidden"
            src={data.notFound.images[3]}
            alt=""
          />
        </div>
        <div className="w-full lg:w-1/2">
          <h1 className="py-4 text-3xl lg:text-4xl font-extrabold text-gray-800">
          {data.notFound.title}
          </h1>
          <p className="py-4 text-base text-gray-800">
          {data.notFound.desc}
          </p>
          <p className="py-2 text-base text-gray-800">
          {data.notFound.desc2}
          </p>
          <Link to="/">
            <button className="w-full lg:w-auto my-4 border rounded-md px-1 sm:px-16 py-5 bg-green-600 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-700 focus:ring-opacity-50">
            {data.notFound.desc3}
            </button>
          </Link>
        </div>
      </div>
    </Container>
  );
};

export default Error404;
